module.exports = __webpack_public_path__ + "img/png.62ac70c4.svg";